import { css } from '@conexasaude/conexa-hero'
import { SerializedStyles } from '@emotion/utils'

export const loadingMixin = (
  color1: string,
  color2: string,
  width: string,
  height: string,
): SerializedStyles => css`
  position: relative;
  background-color: #ccc;
  width: ${width};
  height: ${height};
  min-width: ${width};
  min-height: ${height};
  animation-name: animateLoading;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, ${color1}),
    color-stop(18%, ${color2}),
    color-stop(33%, ${color1})
  );
  background: -webkit-linear-gradient(
    left,
    ${color1} 8%,
    ${color2} 18%,
    ${color1} 33%
  );
  background: linear-gradient(
    to right,
    ${color1} 8%,
    ${color2} 18%,
    ${color1} 33%
  );
  -webkit-background-size: 800px 104px;
`

export const loadingAnimationMixin = (
  color1: string,
  color2: string,
): SerializedStyles => css`
  position: relative;
  background-color: #ccc;
  animation-name: animateLoading;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, ${color1}),
    color-stop(18%, ${color2}),
    color-stop(33%, ${color1})
  );
  background: -webkit-linear-gradient(
    left,
    ${color1} 8%,
    ${color2} 18%,
    ${color1} 33%
  );
  background: linear-gradient(
    to right,
    ${color1} 8%,
    ${color2} 18%,
    ${color1} 33%
  );
  -webkit-background-size: 800px 104px;
`

export default loadingMixin
